import { TextHFourIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Heading4 = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <TextHFourIcon size={Sizes[size]} {...rest} color={fill} />;
};

Heading4.displayName = 'Heading4';
